import React from "react";
import {Dropdown} from "primereact/dropdown";

// 24-hour time picker (HH:MM every 15 minutes). The native <input type="time"> follows the OS locale (AM/PM).
const faTime = (value) => value.replace(/\d/g, (digit) => "۰۱۲۳۴۵۶۷۸۹"[digit]);
const TIMES = Array.from({length: 96}, (_, step) => {
    const value = `${String(Math.floor(step / 4)).padStart(2, "0")}:${String((step % 4) * 15).padStart(2, "0")}`;
    return {label: faTime(value), value};
});

export default function TimeSelect({value, onChange, disabled, ariaLabel}) {
    const current = /^\d{2}:\d{2}$/.test(value || "") ? value : "08:00";
    const options = TIMES.some((option) => option.value === current)
        ? TIMES
        : [...TIMES, {label: faTime(current), value: current}].sort((a, b) => a.value.localeCompare(b.value));
    return (
        <Dropdown
            value={current}
            options={options}
            onChange={(event) => onChange(event.value)}
            disabled={disabled}
            className="text-xs"
            style={{minWidth: "7.5rem"}}
            panelClassName="text-xs notification-settings-dialog"
            scrollHeight="16rem"
            aria-label={ariaLabel}
            filter={false}
        />
    );
}
